import { authGuard, permissionGuard } from '@abp/ng.core';
import { Routes } from '@angular/router';
import { GDPR_COOKIE_CONSENT_ROUTES } from './gdpr-cookie-consent/gdpr-cookie-consent.routes';
import { HomeComponent } from './home/home.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent,
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(c => c.DashboardComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'admin/training-review',
    loadChildren: () =>
      import('./admin/training-review/training-review.routes').then(m => m.TRAINING_REVIEW_ROUTES),
    canActivate: [authGuard, permissionGuard],
    data: { requiredPolicy: 'UseIt.Admin.TrainingReview' },
  },
  {
    path: 'admin/minddex',
    loadChildren: () => import('./admin/minddex/minddex.routes').then(m => m.MINDDEX_ROUTES),
    canActivate: [authGuard, permissionGuard],
    data: { requiredPolicy: 'UseIt.Admin.MindDex' },
  },
  {
    path: 'admin/client-release',
    loadChildren: () => import('./admin/client-release/release.routes').then(m => m.RELEASE_ROUTES),
    canActivate: [authGuard, permissionGuard],
    data: { requiredPolicy: 'UseIt.Admin.Release' },
  },
  {
    path: 'admin/feature-access',
    loadChildren: () =>
      import('./admin/feature-access/feature-access.routes').then(m => m.FEATURE_ACCESS_ROUTES),
    canActivate: [authGuard, permissionGuard],
    data: { requiredPolicy: 'UseIt.Admin.FeatureAccess' },
  },
  {
    path: 'account',
    loadChildren: () => import('@volo/abp.ng.account/public').then(c => c.createRoutes()),
  },
  {
    path: 'gdpr',
    loadChildren: () => import('@volo/abp.ng.gdpr').then(c => c.createRoutes()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(c => c.createRoutes()),
  },
  {
    path: 'language-management',
    loadChildren: () => import('@volo/abp.ng.language-management').then(c => c.createRoutes()),
  },
  {
    path: 'ai-management',
    loadChildren: () => import('@volo/abp.ng.ai-management').then(c => c.createRoutes()),
  },
  {
    path: 'cms',
    loadChildren: () =>
      Promise.all([
        import('@volo/abp.ng.cms-kit-pro/admin').then(c => c.createRoutes()),
        import('@abp/ng.cms-kit/admin').then(c => c.createRoutes()),
      ]).then(([proRoutes, cmsKitRoutes]) => [...proRoutes, ...cmsKitRoutes]),
  },
  {
    path: 'audit-logs',
    loadChildren: () => import('@volo/abp.ng.audit-logging').then(c => c.createRoutes()),
  },
  {
    path: 'openiddict',
    loadChildren: () => import('@volo/abp.ng.openiddictpro').then(c => c.createRoutes()),
  },
  {
    path: 'text-template-management',
    loadChildren: () => import('@volo/abp.ng.text-template-management').then(c => c.createRoutes()),
  },
  {
    path: 'gdpr-cookie-consent',
    children: GDPR_COOKIE_CONSENT_ROUTES,
  },
  {
    path: 'setting-management',
    loadChildren: () => import('@abp/ng.setting-management').then(c => c.createRoutes()),
  },
];
